export enum SearchOption {
  PRODUCT = 'Products',
  BRANCHES = 'Branches',
}

export type SearchOptions = {
  [id in SearchOption]: string;
};
